import { jsxs as n, jsx as s } from "react/jsx-runtime";
import { c as l } from "../../clsx-OuTLNxxd.js";
import { formatPrice as m } from "../utils.js";
const u = "PriceBox-module_price-box__ZJgbg",
  p = "PriceBox-module_price-value__ZvIGK",
  b = "PriceBox-module_discounted__leeK8",
  _ = "PriceBox-module_discounted-inverted__zlt8x",
  x = "PriceBox-module_secondary__9b9fr",
  B = "PriceBox-module_label-uppercase__KeC0A",
  P = "PriceBox-module_top-label__btPVl",
  v = "PriceBox-module_bottom-label__z0ake",
  y = "PriceBox-module_bottom-disclaimer__Y10qW",
  e = {
    priceBox: u,
    priceValue: p,
    discounted: b,
    discountedInverted: _,
    secondary: x,
    labelUppercase: B,
    topLabel: P,
    bottomLabel: v,
    bottomDisclaimer: y
  },
  V = _ref => {
    let {
      price: o,
      chipBackgroundColor: c = "white",
      topLabel: t,
      bottomLabel: i,
      rightLabel: a,
      className: d,
      priceType: r = "primary"
    } = _ref;
    return /* @__PURE__ */n("div", {
      className: l(e.priceBox, d),
      children: [t, /* @__PURE__ */s(L, {
        price: o,
        chipBackgroundColor: c,
        priceType: r,
        children: a
      }), /* @__PURE__ */s("div", {
        className: e.bottomDisclaimer,
        children: i
      })]
    });
  },
  L = _ref2 => {
    let {
      price: o,
      chipBackgroundColor: c,
      children: t,
      className: i,
      priceType: a,
      dataTestId: d,
      inverted: r = !1
    } = _ref2;
    return /* @__PURE__ */n("div", {
      className: l(e.priceValue, {
        [e.discounted]: o.type == "discounted",
        [e.secondary]: a == "secondary",
        [e.discountedInverted]: o.type === "discounted" && r
      }, i),
      "data-test-id": d,
      children: [m(o, c, r), t]
    });
  },
  I = _ref3 => {
    let {
      className: o,
      uppercase: c,
      children: t
    } = _ref3;
    return /* @__PURE__ */s("div", {
      className: l(e.topLabel, {
        [e.labelUppercase]: c
      }, o),
      children: t
    });
  },
  U = _ref4 => {
    let {
      className: o,
      uppercase: c,
      children: t
    } = _ref4;
    return /* @__PURE__ */s("div", {
      className: l(e.bottomLabel, {
        [e.labelUppercase]: c
      }, o),
      children: t
    });
  };
export { V as PriceBox, U as PriceBoxBottomLabel, I as PriceBoxTopLabel, L as PriceValue };